module.exports = __webpack_public_path__ + "img/head-side-virus.7ad6b6f3.svg";